__webpack_require__.p = "/assets/turbo/6ab6080c/universalat/_next/";